"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transferUserDataForEditableDesignAssetLayers;
const EditableDesignAssetLayer_1 = require("../../models/layers/EditableDesignAssetLayer");
const compareByReadingOrder_1 = __importDefault(require("./compareByReadingOrder"));
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
/**
 * This function finds the editable design asset layers and transfers any user data that may have existed to the new layers in reading order and returns the new layers
 * @param oldLayers Layers from the old design that may contain user data
 * @param templateLayers Layers for the new design from the HAMMER template
 * @returns Editable design asset layers from the template filled with prior user data if available
 */
function transferUserDataForEditableDesignAssetLayers(oldLayers, templateLayers) {
  let oldEditableDesignAssetLayers = oldLayers.filter(layer => (0, EditableDesignAssetLayer_1.isEditableDesignAssetLayer)(layer)).sort(compareByReadingOrder_1.default); // Ensure that data is transferred in reading order
  const newEditableDesignAssetLayers = templateLayers.filter(layer => (0, EditableDesignAssetLayer_1.isEditableDesignAssetLayer)(layer)).map(layer => (0, lodash_clonedeep_1.default)(layer)) // Ensure we're not modifying the original layer object from the template
  .sort(compareByReadingOrder_1.default); // Ensure that data is transferred in reading order
  newEditableDesignAssetLayers.forEach(newLayer => {
    let oldLayer;
    // if the new layer we're transferring data too is on the right, find the first available old layer also on the right
    if (newLayer.id.includes('--SHIFTED')) {
      oldLayer = oldEditableDesignAssetLayers.find(l => l.id.includes('--SHIFTED'));
    } else {
      oldLayer = oldEditableDesignAssetLayers.find(l => !l.id.includes('--SHIFTED'));
    }
    if (oldLayer) {
      // If an old layer was found, copy the data from the old layer, to the new layer
      if (oldLayer.userData) {
        newLayer.userData = oldLayer.userData;
      }
      // then remove it from the list, so we don't transfer the same data multiple times
      const oldLayerId = oldLayer.id;
      oldEditableDesignAssetLayers = oldEditableDesignAssetLayers.filter(l => l.id !== oldLayerId);
    }
  });
  return newEditableDesignAssetLayers;
}